import React from 'react';

import { Modal } from 'src/components/common';
import { InviteVerifierStaffModalForm } from 'src/components/verifierStaff';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export const InviteVerifierStaffByVerifierAdminModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen } = useModal(
    ModalId.InviteVerifierStaffByVerifierAdmin,
  );

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Invite Staff"
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
      maxWidth={600}
      headerPadding="32px 32px 4px"
      headerProps={{
        sx: {
          lineHeight: '28px',
        },
      }}
      contentProps={{
        sx: {
          pt: 0,
        },
      }}
    >
      <InviteVerifierStaffModalForm
        closeModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
